import { adminHttpClient } from '../../../../commons/adminHttpClient'
import { BaseProductClassValues } from './baseProductClass'

export interface CostSharingPercentageValues extends BaseProductClassValues {
  eECoinsurance: boolean | null
  eECoinsuranceAmount: number | null
}

const costSharingPercentageApi = (selectClassValues: CostSharingPercentageValues): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/ClassDesign/CostSharingPercentage', selectClassValues)
}

export default costSharingPercentageApi
